module.exports = __webpack_public_path__ + "img/comesoon.3e9c9a09.png";